import { Time } from 'lightweight-charts';
import { addIndex, equals, filter, length, map, pipe } from 'ramda';
import { compact } from 'ramda-adjunct';
import { ChartData, ChartRange, ChartRangeSift } from '../entities';
import { formatTime } from './formatTime';

// Ramda can't typify addIndex
const filterIndexed = addIndex(filter) as any;

export const modifyDataByCandlestickChart = (items: ChartData[]): ChartData[] =>
  items
    .filter(item => item?.open !== undefined)
    .map((chartElement: ChartData) => ({
      ...chartElement,
      time: formatTime(Number(chartElement.time)),
    }));

interface LineChartData {
  time: Time;
  value: number;
}
export const modifyDataByLineChart = pipe<ChartData[], LineChartData[], LineChartData[]>(
  map((chartData: ChartData) => ({
    time: formatTime(Number(chartData.time)),
    value: chartData.open || chartData.close,
  })),
  compact,
);

const MIN_DATA_VOLUME = 100;

export const getSiftedChartValues = (chartData: ChartData[], chartRange: ChartRange) =>
  length(chartData) < MIN_DATA_VOLUME
    ? chartData
    : filterIndexed((_: ChartData, idx: number) => equals(idx % ChartRangeSift[ChartRange[chartRange]], 0), chartData);
